import { render, staticRenderFns } from "./FormCashDonationGiftQuestionItemSettings.vue?vue&type=template&id=671ee2d2"
import script from "./FormCashDonationGiftQuestionItemSettings.vue?vue&type=script&lang=js"
export * from "./FormCashDonationGiftQuestionItemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports